import { SQUARE_ASPECTS_STRING } from '@anm/data/aspects';

import { TemplatePage } from './types';

const adsPromoPage: TemplatePage = {
  header: {
    color: '#EBA4A8',
    icon: 'images/video-templates/ads-promo.jpg',
    title: 'Ads & Promo Video Templates',
    title_meta: '500+ Customizable Ads & Promo Video Templates',
    description_meta:
      'Choose from the collection of 400+ free promo video templates to create amazing promotional videos and ' +
      'video ads in minutes.',
    description:
      'Take your video marketing to the next level with Wave.video’s collections of attention-grabbing ads & promo ' +
      'video templates. Customizable and free!'
  },
  footer: {
    category: 'ads & promo',
    description:
      'With Wave.video’s collections of ads & promo video templates, you won’t need to hire a high-end graphic ' +
      'designer to make effective video content for your business. Just pick a template that suits your needs best, ' +
      'customize it to your branding, and download or share directly on social media. Easy as one-two-three!'
  },
  content: [
    {
      type: 'slider',
      title: 'Video Ad Templates',
      name: 'ads-promo-ads',
      search: { category: '/Use Cases/Ads', aspects: SQUARE_ASPECTS_STRING }
    },
    {
      type: 'slider',
      title: 'Lyric Video Templates',
      name: 'use-cases-lyric',
      search: { name: 'lyric', aspects: SQUARE_ASPECTS_STRING }
    },
    {
      type: 'slider',
      title: 'News Video Templates',
      name: 'use-cases-news',
      search: { name: 'news', aspects: SQUARE_ASPECTS_STRING }
    },
    {
      type: 'slider',
      title: 'Promo Video Templates',
      name: 'ads-promo-promo',
      search: {
        category: '/Use Cases/Promotional Videos',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Video Quote Templates',
      name: 'use-cases-quotes',
      search: {
        category: '/Use Cases/Quote Videos',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Customer Testimonial Video Templates',
      name: 'ads-promo-testimonials',
      search: {
        category: '/Use Cases/Customer Testimonial',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'stocks',
      title: 'promotional',
      search: { name: 'promo, promotional', aspects: SQUARE_ASPECTS_STRING }
    },
    {
      type: 'calendar'
    }
  ]
};

export default adsPromoPage;
